export default {"src":"/_next/static/media/ultra.4d991441.svg","height":12,"width":148};